module.exports = __webpack_public_path__ + "static/media/google.9a4be372.svg";